import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("dd_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !String(e.config?.url).includes("/auth/")) {
      const sent = String(e.config?.headers?.Authorization || "").replace("Bearer ", "");
      if (sent && sent !== localStorage.getItem("dd_token")) return Promise.reject(e);
      localStorage.removeItem("dd_token");
      const target = window.location.pathname.startsWith("/a/") ? "/admin/login" : "/login";
      if (window.location.pathname !== target) window.location.href = target;
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const usd = (n) => `$${Number(n || 0).toFixed(2)}`;
export const fmtDT = (s) =>
  s ? new Date(s).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";
export const fmtWindow = (a, b) => {
  if (!a) return "—";
  const s = new Date(a), e = new Date(b);
  const day = s.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
  const t = (d) => d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  return `${day} · ${t(s)}–${t(e)}`;
};
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : "");
export const mapsLink = (c) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([c.address, c.city, c.state || "OH", c.zip].filter(Boolean).join(", "))}`;

export const STATUS = {
  draft: "Draft", open: "Open", assigned: "Assigned", en_route: "En route", before_check: "Before-work check",
  working: "Working", after_check: "After-work check", awaiting_review: "Awaiting review", completed: "Completed",
  cancelled: "Cancelled",
};
export const FLOW = ["assigned", "en_route", "before_check", "working", "after_check", "awaiting_review", "completed"];

export const SERVICES = [
  ["oil_change", "Oil change", "mechanical"], ["diagnostics", "Initial diagnostics", "mechanical"],
  ["brake_pads_axle", "Brake pads (per axle)", "mechanical"], ["pads_rotors_axle", "Pads & rotors (per axle)", "mechanical"],
  ["calipers", "Calipers", "mechanical"], ["battery", "Battery", "mechanical"], ["spare_tire", "Spare-tire installation", "mechanical"],
  ["tire_service", "Qualified tire service", "mechanical"], ["interior_detail", "Interior detailing", "detailing"],
  ["exterior_detail", "Exterior detailing", "detailing"], ["full_detail", "Combined detailing", "detailing"],
];
export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export async function downloadBlob(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
